import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from "@master/core/dist/core";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class LoggerService extends BaseService {
	constructor(
		private http: HttpClient,
		public appConfigService: AppConfigService
	  ) {
		super(appConfigService);
	  }

	public log(message){
		let data = ` - [QR-generator] - ${message}`;
		return this.http.post(`${this.getUrl()}/utils/log`, { data }).toPromise();
	}
	public error(message){
		let data = ` - [QR-generator] - ${message}`;
		return this.http.post(`${this.getUrl()}/utils/error`, { data }).toPromise();
	}
	public debug(message){
		let data = ` - [QR-generator] - ${message}`
		return this.http.post(`${this.getUrl()}/utils/debug`, { data }).toPromise();
	}
	
	 
}